/** Max width for desktop app-bar quick-add (fits full NL/EN placeholder at 1440px). */
export const QUICK_ADD_DESKTOP_MAX_WIDTH_PX = 620;

/** Shared quick-add input chrome for MobileQuickBar and desktop QuickBar. */
export const QUICK_ADD_INPUT_SX = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderStyle: 'dashed',
  },
  '& .MuiOutlinedInput-input': {
    textOverflow: 'ellipsis',
  },
};

/** Ellipsis for inline quick-add fields (lists, calendar). */
export const QUICK_ADD_PLACEHOLDER_INPUT_SX = {
  '& .MuiOutlinedInput-input': {
    textOverflow: 'ellipsis',
  },
};
